import { CHANNEL_CONNECTION_INSTAGRAM_EMAIL_REGISTRATION_ALERT, } from '../../ChannelsSegmentEvents';
export class InstagramSuccesConnectModalController {
    static $inject = ['close', 'application', 'InstagramService', 'AccountService2', 'BlipService', 'BlipToastService', 'SegmentService', '$translate', '$timeout'];
    constructor(close, application, InstagramService, AccountService2, BlipService, BlipToastService, SegmentService, $translate, $timeout) {
        'ngInject';
        this.close = close;
        this.application = application;
        this.InstagramService = InstagramService;
        this.AccountService2 = AccountService2;
        this.BlipService = BlipService;
        this.BlipToastService = BlipToastService;
        this.SegmentService = SegmentService;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.emails = [];
        this.emailRegex = /^(.+)@(\S+)$/;
        this.connectButtonDisabled = false;
        this.onModalChanged = async () => {
            await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_EMAIL_REGISTRATION_ALERT, { isSkipStep: true });
            this.close();
        };
        this.onConfirmConnected = async () => {
            if (!this.connectButtonDisabled) {
                const numberSavedEmails = this.emails.length;
                try {
                    let savedEmails = await this.concatSavedEmailsAsync(this.emails);
                    savedEmails = this.onlyUniquiEmails(savedEmails);
                    await this.InstagramService.setEmailsAsync(savedEmails);
                    this.BlipToastService.show('success', {
                        title: await this.$translate('instagram.modals.connected.successMsg.title'),
                        msg: await this.$translate('instagram.modals.connected.successMsg.msg'),
                    });
                    await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_EMAIL_REGISTRATION_ALERT, {
                        isEmailSaved: true,
                        numberSavedEmails: numberSavedEmails,
                    });
                    this.close();
                }
                catch (error) {
                    console.error(error);
                    this.BlipToastService.show('danger', {
                        title: await this.$translate('instagram.modals.connected.errorMsg.title'),
                        msg: await this.$translate('instagram.modals.connected.errorMsg.msg'),
                    });
                    await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_EMAIL_REGISTRATION_ALERT, {
                        isEmailSaved: false,
                    });
                }
            }
        };
        this.onChangeEmail = async (event) => {
            let enabledButton = true;
            if (this.emails.join(',') !== event.detail.data?.join(',')) {
                const emailInput = event.target;
                this.emails = event.detail.data;
                if (this.emails.length == 0) {
                    this.setConectedButtonStatus(false);
                    return;
                }
                this.emails.forEach((email) => {
                    if (!this.emailRegex.test(email)) {
                        enabledButton = false;
                    }
                });
                this.setConectedButtonStatus(enabledButton);
                this.setDagerInput(enabledButton, emailInput);
            }
        };
        this.setDagerInput = (enabledButton, emailInput) => {
            this.$timeout(() => {
                if (enabledButton) {
                    emailInput.removeAttribute('danger');
                }
                else {
                    emailInput.setAttribute('danger', 'true');
                }
            });
        };
        this.setConectedButtonStatus = (enabledButton) => {
            this.$timeout(() => {
                if (enabledButton) {
                    this.connectButtonDisabled = false;
                }
                else {
                    this.connectButtonDisabled = true;
                }
            });
        };
    }
    $onInit() {
        try {
            document
                .getElementById('emails-input')
                .addEventListener('bdsChangeChips', this.onChangeEmail);
            document
                .getElementById('instagram-success-connect-modal')
                .addEventListener('bdsModalChanged', this.onModalChanged);
            this.addUserEmail();
        }
        catch (error) {
            console.error(error);
        }
    }
    onConfirm() {
        this.close();
    }
    async onSkipStepAsync() {
        await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_EMAIL_REGISTRATION_ALERT, { isSkipStep: true });
        this.close();
    }
    async trackApplicationEvent(event, payload) {
        const application = this.application;
        await this.SegmentService.createApplicationTrack({
            trackEvent: event,
            application,
            payload: { ...payload },
        });
    }
    onlyUniquiEmails(emails) {
        const unique = emails.filter((value, index, array) => array.indexOf(value) === index);
        return unique;
    }
    async concatSavedEmailsAsync(emails) {
        let savedEmails = [];
        try {
            savedEmails = await this.InstagramService.getEmailsAsync();
            return emails.concat(savedEmails);
        }
        catch (error) {
            console.error(error);
        }
        return emails;
    }
    async addUserEmail() {
        try {
            const user = await this.retrieveUser();
            if (user?.email) {
                this.emails.push(user.email);
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    async retrieveUser() {
        return this.BlipService.isConnected() && (await this.AccountService2.me());
    }
}
InstagramSuccesConnectModalController.$inject = ['close', 'application', 'InstagramService', 'AccountService2', 'BlipService', 'BlipToastService', 'SegmentService', '$translate', '$timeout'];
